import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
//import { isEmpty, includes } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button"

//import { toast } from 'react-toastify';

import { get } from 'lodash';

import { Spinner } from '~/components';
import { Input, Hidden, Select } from '~/components/Form';

import { t, validCharacters } from '~/helpers';
//import api from '~/services/api';

import { Container } from './styles';
import * as S from './styles';

//import { closeDialog } from '~/store/modules/dialog/actions';

import { storeOperacaoImpedimentos, updateOperacaoImpedimentos } from '~/store/modules/operacaoimpedimentos/actions';

export default function CreateOrUpdate({ reference, data, create, close, sending, visible }) {
  const dispatch = useDispatch();


  const statusSimNao = [
    { label: 'Não', value: 'N' },
    { label: 'Sim', value: 'L' },
  ];

  const [liberaAbasecimento, setLiberaAbasecimento] = React.useState(false);




  //const [selected, setSelected] = React.useState([]);
  //const [fecharForm, setFecharForm] = React.useState(false);
  const { usuarioacesso } = useSelector((state) => state.user);
  //const [isLoading, setIsLoading] = useState(false);


  async function handleLiberaAbasecimento(value) {
    setLiberaAbasecimento(value);
    await reference.current.setFieldValue('status_liberado', value);
  }


  //********************** */
  //********************** */
  //***TESTE DIALOG  INICIO*/
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("CLICK-OK");
  // const handleClickListItem = () => {
  //   setOpen(true);
  // };
  const handleClose = (newValue) => {
    setOpen(false);
    if (newValue) {
      setValue(newValue);
    }
  };

  function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const radioGroupRef = React.useRef(null);

    React.useEffect(() => {
      if (!open) {
        setValue(valueProp);
      }
    }, [valueProp, open]);

    const handleEntering = () => {
      if (radioGroupRef.current != null) {
        radioGroupRef.current.focus();
      }
    };

    const handleCancel = () => {
      onClose();
    };

    const handleOk = () => {
      onClose(value);
    };

    // const handleChange = (event) => {
    //   setValue(event.target.value);
    // };

    //const isSelected = (name) => selected.indexOf(name) !== -1;

    useEffect(() => {
      if (sending && reference.current) reference.current.submitForm()
    }, [sending]);



    return (
      <div>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="xs"
          onEntering={handleEntering}
          aria-labelledby="confirmation-dialog-title"
          open={open}
          {...other}
        >
          <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle>
          <DialogContent dividers>
            <span>O KM anterior é maior que o KM atual. Deseja Salvar?</span>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleOk} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  //***TESTE DIALOG  FIM*/
  //********************** */
  //********************** */


  const { loading, find, params } = useSelector(
    (state) => state.operacaoimpedimentos
  );

  const initials = create ? data : { ...find, ...data };


  async function handleSubmit(param) {

    try {

      const schema = Yup.object().shape({
        status_liberado: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

        imab_horas_validade: liberaAbasecimento === 'L' ? Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Deve ser maior que 0!')
          .max(
            8,
            'O campo hora válida está acima do máximo permitido (8 horas)!'
          ) :
          Yup.number().typeError('Deve ser um número maior que 0')
        ,

        imab_obs: liberaAbasecimento === 'L' ? Yup.string()
          .trim()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(250, 'Tamanho máximo 250 de caracteres!')
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ) : Yup.string().nullable(),



      });

      await schema.validate(param, {
        abortEarly: false,
      });



      // if (fecharForm) {
      //   await dispatch(closeDialog());
      //   return;
      // }


      const imab_codigo = get(data, 'imab_codigo', '');

      const orga_codigo = get(usuarioacesso, 'orga_codigo', '');
      const usua_login = get(usuarioacesso, 'usua_login', '');
      const status_liberado = get(param, 'status_liberado', '');
      const imab_horas_validade = get(param, 'imab_horas_validade', '');

      let imab_obs = get(param, 'imab_obs', '');

      if (!imab_obs) {
        imab_obs = '';
      }

      // const objSend = {
      //   imab_codigo: imab_codigo,
      //   orga_codigo: orga_codigo,
      //   usua_login: usua_login,
      //   status_liberado: status_liberado,
      //   imab_horas_validade: imab_horas_validade,
      //   imab_obs : imab_obs,
      // }

      const objSend = {
        imab_codigo: imab_codigo,
        usua_nome: '',
        usua_login: usua_login,
        poco_codigo: '',
        poco_desc_abrev: '',
        poco_descricao: '',
        unid_codigo: '',
        unid_nome: '',
        orga_codigo: orga_codigo,
        orga_nome: '',
        veic_placa: '',
        cond_cpf: '',
        cond_nome: '',
        imab_data_registro: null,
        imab_data_liberacao: null,
        imab_tipo: '',
        desc_tipo: '',
        imab_liberado: status_liberado,

        imab_horas_validade: imab_horas_validade,
        imab_obs: imab_obs,
        veic_placa_aux: '',
      }

      if (create) {
        await dispatch(storeOperacaoImpedimentos(objSend, params));
      } else {
        await dispatch(updateOperacaoImpedimentos(objSend, params));
      }

      close();

    } catch (err) {
      console.log(err)
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }



  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
        //if (veiculo !== undefined && veiculo !== null) {
        //initials.idveiculo = veiculo;
        //}
        //reference.current.setData(initials);                
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [loading, initials]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {

      if (create) {
        //setPreRecebimentoVO([]);
        console.log('Incluir');
      } else {
        console.log('Alterar');
        // const {
        //   prre_codigo,
        //   prre_status,
        //   poco_codigo,
        //   prod_codigo,
        //   prod_codigo_display,
        //   notasFiscais,
        // } = find;

        // const obj = {
        //   prre_codigo,
        //   prre_status,
        //   poco_codigo,
        //   prod_codigo_display,
        //   prod_codigo,
        //   notasFiscais,
        // }
        // setPreRecebimentoVO(obj);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);


  return (
    <S.Container2>


      {/* {isLoading ?
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div> : ''
      } */}

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (


        !create && initials.imab_liberado === 'L' ? (
          <div style={{ height: '14rem', width: '50rem' }}>
            <p>Registro não pode ser alterado!'</p>
          </div>
        ) : (

          <>
            <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
              <S.Container2>
                <Hidden
                  name="imab_codigo"
                  label='Cód Impedimento:'
                />

                <Select
                  name="status_liberado"
                  label={'Libera Abastecimento:'}
                  options={statusSimNao}
                  onChange={({ target }) => handleLiberaAbasecimento(target.value)}
                />



                <Input
                  name="imab_horas_validade"
                  label='Horas Valida:'
                  type="number"
                />

                <Input
                  name="imab_obs"
                  multiline
                  rows={10}
                  label='Justificativa:'

                />
              </S.Container2>


            </Form>
          </>
        )
      )
      }

      <div >
        {/* <Button variant="outlined" color="primary" onClick={handleClickListItem}>
                  Open dialog
                </Button> */}

        <ConfirmationDialogRaw
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
        />
      </div>
    </S.Container2>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
